/**
 * @Author: v_jppjpeng
 * @Date: 2024-11-07 15:13:19
 * @Explain: 模板管理
 */

export default {
  // 填写模板名称校验失败
  301: 'templateAddName',
  // 拖拽column失败
  302: 'templateColumnsError',
  // 拖拽Text失败
  303: 'templateTextError',
  // 拖拽Button失败
  304: 'templateButtonError',
  // 拖拽Img失败
  305: 'templateImageError',
  // 拖拽Img失败
  306: 'templateGroupSocialError',
  // 拖拽Driver失败
  307: 'templateDividerError',
  // 保存模板失败
  308: 'templateSaveError',
  // 发送模版测试异常
  309: 'templateSendError',
  // 删除模版异常
  310: 'templateDeleteError',
};
